import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
    root: {
       display: 'flex',
       boxSizing: 'border-box',
       width: '100%',
       height: '100%',
    },

    canvas: {
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        cursor: 'move',
    },
}));
